export var BinarySensorType;
(function (BinarySensorType) {
    BinarySensorType[BinarySensorType["CONTACT"] = 0] = "CONTACT";
    BinarySensorType[BinarySensorType["CUSTOM"] = 1] = "CUSTOM";
    BinarySensorType[BinarySensorType["DOOR"] = 2] = "DOOR";
    BinarySensorType[BinarySensorType["LOCK"] = 3] = "LOCK";
    BinarySensorType[BinarySensorType["MOTION"] = 4] = "MOTION";
    BinarySensorType[BinarySensorType["WINDOW"] = 5] = "WINDOW";
})(BinarySensorType || (BinarySensorType = {}));
export var SwitchType;
(function (SwitchType) {
    SwitchType[SwitchType["CUSTOM"] = 0] = "CUSTOM";
    SwitchType[SwitchType["OUTLET"] = 1] = "OUTLET";
    SwitchType[SwitchType["SWITCH"] = 2] = "SWITCH";
})(SwitchType || (SwitchType = {}));
//# sourceMappingURL=types.js.map